import * as React from "react";
import styled from "styled-components"
import SwiperCore, { EffectCards, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.scss';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/pagination/pagination.scss';
SwiperCore.use([EffectCards, Navigation, Pagination]);
import colors from "../../globals/colors";
import { IsHorizontalMobile, IsMobile, useWindowSize } from "../../globals/UIHooks";

export const ProjectImg = styled.div<{ url: string }>`
    background: ${props => `url(${props.url}) no-repeat center center`};
    background-size: cover;
`


const ProjectImageSlider: React.FC<{ media?: string[] }> = ({ media }) => {

  const { width } = useWindowSize()

  const getUrl = (url: string) => `url(${url})`

  return (
    <Swiper style={{ borderRadius: 5, boxShadow: colors.defaultShadow, margin: 0, minHeight: IsMobile(width) ? 350 : IsHorizontalMobile(width) ? 400 : 417 }}
      effect={'cards'} grabCursor={true} navigation={true} pagination={true}>
      {media && media.map((item, key) => <SwiperSlide key={key} style={{ background:colors.lightest, backgroundImage: getUrl(item), backgroundSize: 'cover', backgroundPosition: 'center' }} />)}
    </Swiper>
  )
}

export default ProjectImageSlider